<div class="modal-body content width-800 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header')}}
    </span>
		<div class="content grid cols-3">
			<app-exg-select-enumeration #VCrcptTyp
			                            [(value)]="dataModelClone.kont_enmIdent_KontaktTyp"
											            [caption]="enumSvc.getFieldCaption('Kontakt', 'kont_enmIdent_KontaktTyp')"
						                      enumerationName="KontaktTyp"
						                      name="type">
			</app-exg-select-enumeration>

			<exg-input #VCContactValue
			           [(ngModel)]="dataModelClone.kontVal"
			           [caption]="enumSvc.getFieldCaption('Kontakt', 'kontVal')"
			           class="span-2">
			</exg-input>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="delete()" class="md-btn"
			        *ngIf="dataModelClone?.kontID">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="!appSvc.helperObj.changed(dataModel, dataModelClone)"
			        class="md-btn">
				{{getGlobal('Create')}}
			</button>
		</div>
	</div>
</div>
